const DEVICE_ID_KEY = 'copima_device_id';

const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // eslint-disable-next-line no-bitwise
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0; // eslint-disable-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8; // eslint-disable-line no-bitwise
    return v.toString(16);
  });
};

export const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = generateUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

export const getTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return null;
  }
};

export const getScreenResolution = () => {
  try {
    return `${window.screen.width}x${window.screen.height}`;
  } catch (e) {
    return null;
  }
};

export const getLanguage = () => {
  try {
    return navigator.language || navigator.userLanguage;
  } catch (e) {
    return null;
  }
};

export const getDeviceInfo = () => ({
  deviceId: getDeviceId(),
  timezone: getTimezone(),
  screenResolution: getScreenResolution(),
  language: getLanguage(),
});

export const clearDeviceId = () => {
  localStorage.removeItem(DEVICE_ID_KEY);
};

const deviceUtils = {
  getDeviceId,
  getDeviceInfo,
  getTimezone,
  getScreenResolution,
  getLanguage,
  clearDeviceId,
};

export default deviceUtils;
